<template>
  <div class="home">
    <menuBox :step="1"></menuBox>
    <div class="tes-box">
      <div class="text-box">Ayudar a los usuarios a resolver problemas de préstamos</div>
      <img src="../assets/img-2.png" alt="">
    </div>
    <div class="list-box">
      <div class="line-box"></div>
      <div class="title">Ventajas del producto</div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/icon-1.png" alt="">
          <div>Aprobación rápida del préstamo</div>
          <p>La solicitud es sencilla y la aprobación se completa en 24 horas.</p>
        </div>
        <div class="item">
          <img src="../assets/icon-2.png" alt="">
          <div>Seguro y confiable</div>
          <p>La tecnología de cifrado avanzada garantiza la seguridad de la información y las transacciones personales.</p>
        </div>
        <div class="item">
          <img src="../assets/icon-3.png" alt="">
          <div>Método de pago conveniente</div>
          <p>Admite múltiples canales de pago, pagos flexibles y operación simple.</p>
        </div>
      </div>

    </div>

    <div class="sen-box">
      <div class="sen-left">
        <div class="title">Proceso de uso de la aplicación</div>
        <div class="bj-s-box">
          <p>Descargar</p>
          <p>Autenticación</p>
          <p>Enviar solicitud de préstamo</p>
        </div>
      </div>
      <img src="../assets/img-2.png" alt="">
    </div>

    <div class="del-data-box">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">Al utilizar la función de eliminación de datos, para proteger su información, necesitará verificar su identidad.</div>
        <div class="title">Por favor, ingrese su número de teléfono móvil.</div>
        <input v-model="mobile" type="text" class="tel-in" placeholder="Por favor, ingrese su número de teléfono móvil.">
        <input v-model="password" type="password" class="tel-pa" placeholder="Ingrese la contraseña de la aplicación.">
        <div class="btn" @click="delSearch">Siguiente</div>
      </div>

      <div class="tel-box" v-else-if="steps == 2">
        <div class="text-box">
          Estimado usuario:
          <br>¡Hola! Agradecemos sinceramente que haya elegido utilizar la aplicación .
          <br> Antes de solicitar la eliminación de su cuenta, por favor asegúrese de que todas sus órdenes estén completadas y que no haya órdenes pendientes de revisión. Tenga en cuenta que una vez que se elimine la cuenta, los datos no podrán ser recuperados. Por favor, confirme cuidadosamente antes de proceder. Esta aplicación no asume ninguna responsabilidad por pérdidas personales o financieras derivadas de esta acción.
          <br> Si confirma que desea eliminar sus datos, por favor haga clic en el botón a continuación.
        </div>
        <div class="btn" @click="candelete">Confirmar eliminación</div>
      </div>
      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">Por favor, ingrese el código de verificación para verificar su identidad.</div>
        <div class="iump-box">
          <input v-model="code" type="text" class="car-in tel-in" placeholder="Ingrese el código de 4 dígitos.">
          <div class="count-btn" @click="Reenviar"> {{ Time > 0 ? Time : 'Obtener código de verificación' }} </div>
        </div>
        <div class="btn" @click="doDelete">Eliminar</div>
      </div>
      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="../assets/del.png" alt="">
        <p>¡Sus datos han sido eliminados!</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">Verificar identidad</div>
        <input v-model="idcard" type="text" class="tel-in" placeholder="Por favor, ingrese su número de identificación.">
        <div class="btn" @click="verifyIdCard">Confirmar</div>
      </div>
    </div>

    <div class="flex-box" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="../assets/title-err.png" class="err-img">
          {{ msg }}
        </div>
        <img src="../assets/close.png" class="close" @click="msgDlg = false">
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
import * as api from "@/api/api";
export default {
  name: 'App',
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      mobile: '',
      password: '',
      code: '',
      msgDlg: false,
      msg: '',
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: '',
      verifyIDCard: '',
    }
  },
  mounted() {

  },
  methods: {
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password
      }
      console.log(this.$loading);
      let loding = this.$loading.show({})
      api.delInfoSearch(data).then(res => {
        loding.hide()
        this.infoData = res.data
        this.steps = 2
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id
      }
      let loding = this.$loading.show({})
      api.delInfoCanDelete(data).then(res => {
        loding.hide()
        if (res.data.idcard) {
          this.verifyIDCard = res.data.idcard
          this.steps = 5
        } else {
          this.steps = 3
          this.Reenviar()
        }
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3
        this.Reenviar()
      } else {
        this.msgDlg = true
        this.msg = 'La tarjeta de identificación se ingresó incorrectamente y la verificación falló.'
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return
      }
      this.Countdown(60)
      let data = {
        mobile: this.mobile
      }
      let loding = this.$loading.show({})
      api.delInfoSms(data).then(res => {
        loding.hide()
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    doDelete() {
      if (!this.code) {
        this.msgDlg = true
        this.msg = 'Se debe completar el código de verificación.'
        return
      }
      let loding = this.$loading.show({})
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id
      }
      api.delInfoDoDelete(data).then(res => {
        loding.hide()
        this.steps = 4
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    Countdown(time) {
      this.Time = time
      if (time <= 0) {
        return
      }

      setTimeout(() => {
        this.Countdown(time - 1)
      }, 1000);
    }
  }
}
</script>


<style lang="less" scoped>
.tes-box {
  padding: 120px 360px;
  display: flex;
  align-items: center;
  justify-content: center;

  .text-box {
    font-size: 52px;
    font-weight: bold;
    color: #333333;
    width: 600px;
  }

  img {
    width: 590px;
  }
}

.line-box {
  width: 105px;
  height: 6px;
  background: linear-gradient(312deg, #3EBFBE 0%, #3FB9EE 100%);
  margin: auto;
}

.list-box {
  padding: 80px 360px;
  background: #E9F7F7;

  .title {
    font-size: 60px;
    font-weight: bold;
    color: #1A202C;
    margin-top: 26px;
    text-align: center;
  }

  .item-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 66px;

    .item {
      width: 273px;
      min-height: 187px;
      background: #FFFFFF;
      box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.05);
      border-radius: 7px 7px 7px 7px;
      opacity: 1;
      padding: 50px 30px;

      img {
        width: 58px;
      }

      div {
        font-size: 20px;
        font-weight: normal;
        color: #2D3748;
        margin-top: 20px;
      }

      p {
        font-size: 14px;
        font-weight: 400;
        color: #718096;
        margin-top: 20px;
      }
    }
  }
}

.sen-box {
  padding: 140px 360px;
  display: flex;
  align-content: center;
  justify-content: space-between;

  .sen-left {
    .title {
      font-size: 60px;
      font-weight: bold;
      color: #1A202C;
    }

    .bj-s-box {
      width: 500px;
      background: url(../assets/list.png) no-repeat;
      background-size: 21px 100%;
      min-height: 262px;
      margin-top: 90px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      p {
        margin-left: 30px;
        font-size: 36px;
        font-weight: 400;
        color: #333333;
      }
    }
  }

  img {
    width: 631px;

  }
}

.del-data-box {
  background: #F5F5F5;
  padding: 100px 560px;

  .tel-box {
    min-height: 155px;
    background: #FFFFFF;
    padding: 40px 150px;
    display: flex;
    flex-direction: column;
    align-items: self-start;

    .tip {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }

    .title {
      font-size: 24px;
      font-weight: 400;
      color: #333333;
      margin-top: 24px;
    }

    .tel-in,
    .tel-pa {
      width: 452px;
      height: 60px;
      border-radius: 5px;
      border: 1px solid #EFEFEF;
      margin-top: 14px;
      padding: 0px 24px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 60px;
    }

    .iump-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 24px;
      width: 500px;
    }

    .car-in {
      width: 302px;
      margin: 0;
    }

    .btn {
      width: 452px;
      height: 60px;
      padding: 0px 24px;
      background: #3EBFBE;
      border-radius: 5px;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 60px;
      margin-top: 24px;
      cursor: pointer;
    }

    .count-btn {
      width: 120px;
      height: 60px;
      border-radius: 8px;
      border: 1px solid #EFEFEF;
      line-height: 60px;
      font-size: 16px;
      font-weight: 400;
      color: #3EBFBE;
      text-align: center;
      cursor: pointer;
    }

    .text-box {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }
  }

  .del-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    img {
      width: 97px;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      margin-top: 24px;
    }
  }
}

.flex-box {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: fade(#000, 90%);
  display: flex;
  align-items: center;
  justify-content: center;

  .msg-box {
    position: relative;

    .err-img {
      width: 100px;
      margin-top: -100px;
    }

    .msg {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background: #fff;
      text-align: center;
      color: #999;
      font-size: 26px;
      padding: 50px;
      width: 380px;
      border-radius: 17px;

    }

    .close {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 30px;
    }
  }
}
</style>
